import { z } from 'zod';
import { PinComponentSchema } from '../pin-component';
import { LayoutPartSchema } from '../pin-component/layout-part';
import { TipTapContentSchemaRequired } from '../tiptap-content.schema';
import { BaseInteractiveQuestionPinSettingsSchema, BasePinSchema, BaseTemplateLayoutSchema } from './base-pin';
import { BaseTeacherPinSettingsSchema } from './base-teacher-pin';

export const FillInTheBlanksPinLayoutKeySettingsSchema = z.enum(['TITLE_ONLY']);
export type FillInTheBlanksPinLayoutKey = z.infer<typeof FillInTheBlanksPinLayoutKeySettingsSchema>;
export const FillInTheBlanksPinLayoutPartKeySchema = LayoutPartSchema.extract(['TITLE', 'FILL_IN_THE_BLANKS_AREA']);
export const FillInTheBlanksPinLayoutTemplateSchema = BaseTemplateLayoutSchema.extend(
  z.object({
    key: FillInTheBlanksPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(FillInTheBlanksPinLayoutPartKeySchema, PinComponentSchema.optional()),
  }).shape
);

export type FillInTheBlanksPinLayoutTemplate = z.infer<typeof FillInTheBlanksPinLayoutTemplateSchema>;
export const FillInTheBlanksPinSettingsSchema = BaseInteractiveQuestionPinSettingsSchema.extend(
  z.object({
    layout: FillInTheBlanksPinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(FillInTheBlanksPinLayoutPartKeySchema, z.string().optional()),
    wordBank: z.array(TipTapContentSchemaRequired),
  }).shape
);
export type FillInTheBlanksPinSettings = z.infer<typeof FillInTheBlanksPinSettingsSchema>;

export const FillInTheBlanksPinTypeSchema = z.literal('FILL_IN_THE_BLANKS');

export const FillInTheBlanksPinSchema = BasePinSchema.extend(
  z.object({
    type: FillInTheBlanksPinTypeSchema,
    settings: FillInTheBlanksPinSettingsSchema,
  }).shape
);

export const FillInTheBlanksTeacherPinSettingsSchema = BaseTeacherPinSettingsSchema.extend(
  z.object({
    correctAnswers: z.array(TipTapContentSchemaRequired),
  }).shape
);

export type FillInTheBlanksTeacherPinSettings = z.infer<typeof FillInTheBlanksTeacherPinSettingsSchema>;

export type FillInTheBlanksPin = z.infer<typeof FillInTheBlanksPinSchema>;
